import { Switch, SwitchProps } from '@chakra-ui/react';
import { ChangeEvent } from 'react';
import { useFormContext } from 'react-hook-form';

import { SimpleField, SimpleXProps } from './SimpleField';
import { useSimpleFormContext } from './SimpleForm';

type SimpleSwitchProps = SimpleXProps &
  SwitchProps & {
    fieldLabel?: string;
    fontColor?: string;
    switchProps?: SwitchProps;
  };

export const SimpleSwitch = ({
  name,
  label,
  fieldLabel = '',
  helper,
  ignoreOnBlur = false,
  switchProps,
  variant,
  colorScheme = 'orange',
  size,
  ...rest
}: SimpleSwitchProps) => {
  const { simpleOnBlur } = useSimpleFormContext();
  const { register, watch } = useFormContext();
  const value = watch(name);

  const formProps = register(name);
  const updateForm = (event: ChangeEvent<HTMLInputElement>) => {
    formProps.onBlur(event);
    if (ignoreOnBlur) return;
    simpleOnBlur?.(event);
  };

  return (
    <SimpleField<SwitchProps> name={name} helper={helper} label={fieldLabel} size={size} {...rest}>
      <Switch
        colorScheme={colorScheme}
        variant={variant}
        {...register(name)}
        isChecked={value}
        onChange={updateForm}
        size={size}
        {...switchProps}
      >
        {label}
      </Switch>
    </SimpleField>
  );
};
